"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressionMonitoringCharts = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const SingleValueMonitoringChart_1 = require("./SingleValueMonitoringChart");
// Progression section containing various charts and indicators about survey progression
const ProgressionMonitoringCharts = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("section", { className: "monitoring-section" },
        react_1.default.createElement("h2", null, t('admin:monitoring.ProgressionSection')),
        react_1.default.createElement("div", { className: "monitoring-charts-container" },
            react_1.default.createElement(SingleValueMonitoringChart_1.SingleValueMonitoringChart, { apiUrl: "/api/admin/data/widgets/interviews-completion-rate", valueName: "interviewsCompletionRate", valueTitle: t('admin:monitoring.CompletionRate'), valueUnit: "%" }),
            react_1.default.createElement(SingleValueMonitoringChart_1.SingleValueMonitoringChart, { apiUrl: "/api/admin/data/widgets/started-interviews-count", valueName: "startedInterviewsCount", valueTitle: t('admin:monitoring.InterviewsStarted') }),
            react_1.default.createElement(SingleValueMonitoringChart_1.SingleValueMonitoringChart, { apiUrl: "/api/admin/data/widgets/completed-interviews-count", valueName: "completedInterviewsCount", valueTitle: t('admin:monitoring.InterviewsCompleted') }))));
};
exports.ProgressionMonitoringCharts = ProgressionMonitoringCharts;
//# sourceMappingURL=ProgressionMonitoringCharts.js.map